import React, { useRef, useState } from "react";
import JobDetailsApplyPopup from "../../job-details/components/JobDetailsApplyPopup";

import twitter from "../../home/img/social/twitter.png";
import facebook from "../../home/img/social/facebook.png";
import instagram from "../../home/img/social/instagram.png";
import linkedin from "../../home/img/social/linkedin.png";

export default function Skeleton(props) {
  return (
    <>
      <div>
        {/* <JobDetailsApplyPopup
          showApply={this.state.isapplymodalopen}
          jobdetails={jobdetails}
          handler={this.handler}
        /> */}
        <div class="sticky bottom-0 w-full footer-css">
          <card class="bg-white flex justify-center items-center">
            <div>
              <div className="flex justify-evenly">
                <a href="https://twitter.com/icicibank">
                  <img src={twitter} />
                </a>
                <a href="https://www.facebook.com/icicibank">
                  <img src={facebook} />
                </a>
                <a href="https://instagram.com/icicibank?utm_medium=copy_link">
                  <img src={instagram} />
                </a>
                <a href="https://in.linkedin.com/company/icici-bank">
                  <img src={linkedin} />
                </a>
              </div>
              <p className="fsize14 copywrite-color mt-4">
                ©{new Date().getFullYear()} - ICICI Careers | All right reserved
              </p>
            </div>
          </card>
        </div>
      </div>
    </>
  );
}
